export const FETCH_CATEGORIES = "FETCH_CATEGORIES"
export const CLEAR_CATEGORIES = "CLEAR_CATEGORIES"
export const UPDATE_CATEGORY = "UPDATE_CATEGORY"
export const ADD_CATEGORY = "ADD_CATEGORY"
export const DELETE_CATEGORY = "DELETE_CATEGORY"